/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Seo_TitleInputs */

const cs_form_seo_title = /** @type {(inputs: Form_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO titulek`)
};

const en_form_seo_title = /** @type {(inputs: Form_Seo_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO title`)
};

/**
* | output |
* | --- |
* | "SEO title" |
*
* @param {Form_Seo_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_seo_title = /** @type {((inputs?: Form_Seo_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Seo_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_seo_title(inputs)
	return cs_form_seo_title(inputs)
});